module.exports = __webpack_public_path__ + "img/undraw_empty_cart_co35.5d005a6d.svg";